import styles from './styles.module.css';

interface LoaderProps {
  width?: string;
  height?: string;
}

const Loader = ({ width = '100px', height = '100px' }: LoaderProps) => {
  return (
    <div style={{ width: width, height: height }} className={styles.loader}>
      <svg
        width={width}
        height={height}
        viewBox='0 0 98 104'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <defs>
          <mask id='revealMask'>
            <rect
              className={`${styles.maskRect} ${styles.fourteenth}`}
              x='0'
              y='0'
              width='100%'
              height='100%'
              fill='white'
            />
          </mask>
        </defs>
        <path
          className={`${styles.fadeIn} ${styles.twelfth}`}
          d='M55.2998 50.1662L37.7422 40.0293L31.7274 50.4472L38.9242 54.6022L55.2998 50.1662Z'
          fill='#A568BC'
        />
        <path
          className={`${styles.fadeIn} ${styles.thirteenth}`}
          d='M31.9963 70.4506L49.5568 80.5891L55.5715 70.1713L48.3718 66.0145L31.9963 70.4506Z'
          fill='#A568BC'
        />
        <path
          d='M36.3602 34.2673L36.3572 34.2563L36.3512 34.2668C36.3512 34.2668 36.3582 34.2708 36.3602 34.2673Z'
          fill='#FE8653'
        />
        <path
          className={`${styles.fadeIn} ${styles.tenth}`}
          d='M36.3542 34.2572C36.3542 34.2572 36.3583 34.2635 36.3567 34.2664C37.1869 34.0697 38.0919 34.1596 38.8851 34.6175L62.6486 48.3374L54.1729 29.9049L36.3496 34.2584L36.3542 34.2572Z'
          fill='#FC8753'
        />
        <path
          className={`${styles.fadeIn} ${styles.ninth}`}
          d='M33.0988 18.9507L36.3772 34.2473L18.7525 39.3373L28.9371 21.697C29.8453 20.1239 31.4152 19.1761 33.0988 18.9507Z'
          fill='#42D3A9'
        />
        <path
          className={`${styles.fadeIn} ${styles.seventh}`}
          d='M18.7532 39.3406L20.6824 59.5171L4.57607 63.8962L18.7532 39.3406Z'
          fill='#2797E8'
        />
        <path
          className={`${styles.fadeIn} ${styles.eighth}`}
          d='M36.3779 34.2403C36.3779 34.2403 36.3774 34.2478 36.3803 34.2495C35.5624 34.4919 34.8239 35.0196 34.3673 35.8105L20.6869 59.5056L18.7577 39.3291L36.3824 34.2391L36.3779 34.2403Z'
          fill='#1DBACB'
        />
        <path
          d='M51.0743 86.6624L51.0773 86.6734L51.0833 86.6629C51.0833 86.6629 51.0764 86.6589 51.0743 86.6624Z'
          fill='#FE8653'
        />
        <path
          className={`${styles.fadeIn} ${styles.fourth}`}
          d='M55.9352 101.543L51.0819 86.6659L33.2587 91.0194L50.9499 101.233C52.5276 102.144 54.3638 102.185 55.9352 101.543Z'
          fill='#FD5263'
        />
        <path
          className={`${styles.fadeIn} ${styles.sixth}`}
          d='M33.2549 91.014L24.7821 72.5832L8.63135 76.7975L33.2549 91.014Z'
          fill='#FFCF23'
        />
        <path
          className={`${styles.fadeIn} ${styles.fifth}`}
          d='M51.079 86.6639C51.079 86.6639 51.0749 86.6576 51.0766 86.6547C50.2464 86.8514 49.3414 86.7615 48.5482 86.3036L24.7846 72.5837L33.2604 91.0161L51.0836 86.6627L51.079 86.6639Z'
          fill='#FC8753'
        />
        <path
          className={`${styles.fadeIn} ${styles.third}`}
          d='M54.3342 101.969L51.0558 86.6724L68.6805 81.5824L58.4959 99.2227C57.5877 100.796 56.0178 101.744 54.3342 101.969Z'
          fill='#42D3A9'
        />
        <path
          className={`${styles.fadeIn} ${styles.first}`}
          d='M68.6801 81.5899L66.7493 61.4162L82.8556 57.0372L68.6801 81.5899Z'
          fill='#2797E8'
        />
        <path
          className={`${styles.fadeIn} ${styles.second}`}
          d='M51.0557 86.6786C51.0557 86.6786 51.0562 86.6711 51.0532 86.6695C51.8711 86.4271 52.6097 85.8994 53.0663 85.1085L66.7467 61.4133L68.6759 81.5898L51.0511 86.6798L51.0557 86.6786Z'
          fill='#1DBACB'
        />
        <path
          className={`${styles.fadeIn} ${styles.tenth}`}
          d='M47.8949 26.2768C47.878 26.3597 47.852 26.4451 47.8068 26.5234L47.6278 26.8333C46.7865 28.2906 44.9232 28.7869 43.4618 27.9432C42.0004 27.0994 41.4986 25.2376 42.3399 23.7804L42.5189 23.4704C42.5641 23.3922 42.625 23.3269 42.6884 23.2708L36.4853 19.6894C34.9076 18.7786 33.0714 18.7382 31.5 19.3799L36.3533 34.2569L54.1765 29.9035L47.8949 26.2768Z'
          fill='#FD5263'
        />
        <path
          className={`${styles.fadeIn} ${styles.eleventh}`}
          d='M75.6386 42.3027C75.6217 42.3857 75.5956 42.4711 75.5505 42.5493L75.3715 42.8593C74.5302 44.3165 72.6669 44.8129 71.2054 43.9691C69.744 43.1254 69.2423 41.2636 70.0836 39.8063L70.2626 39.4963C70.3077 39.4181 70.3686 39.3529 70.432 39.2967L54.1761 29.9114L62.6519 48.3439L78.8026 44.1295L75.6415 42.3044L75.6386 42.3027Z'
          fill='#FFCF23'
        />
        <path
          mask='url(#revealMask)'
          d='M75.6058 40.8219L75.6442 40.7552C78.1481 36.4183 78.6465 31.4488 77.4309 26.9383C76.2153 22.4278 73.2847 18.3718 68.9352 15.8607C64.5858 13.3495 59.6079 12.8395 55.0939 14.042C50.5799 15.2446 46.5253 18.1609 44.0214 22.4978L42.9911 24.2824C42.3739 25.3514 42.7442 26.7163 43.8134 27.3336C44.8826 27.9509 46.2514 27.5862 46.8669 26.5201L47.8973 24.7355C49.7857 21.4647 52.8441 19.2673 56.2548 18.3587C59.6654 17.4501 63.4191 17.8327 66.6994 19.7266C69.9796 21.6204 72.1879 24.6799 73.1063 28.0879C74.0248 31.496 73.651 35.2434 71.7626 38.5141L71.7241 38.5808L70.7339 40.2958C70.1167 41.3649 70.487 42.7297 71.5562 43.347C72.6254 43.9644 73.9942 43.5997 74.6098 42.5336L75.5999 40.8185L75.6058 40.8219Z'
          fill='#3D4C66'
        />
      </svg>
    </div>
  );
};

export default Loader;

export const CenteredLoader = () => {
  return (
    <div className='flex w-full h-full items-center justify-center'>
      <Loader />
    </div>
  );
};
